module.exports = __webpack_public_path__ + "img/four2Orange.d0e81f1c.jpg";